import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-form-input-phone-country',
  templateUrl: './input-phone-country.component.html',
  styleUrls: ['./input-phone-country.component.scss'],
})
export class InputPhoneCountryComponent {}
